import DownLoad from './index.vue'
export default DownLoad